import clsx from "clsx";
import { Button, ButtonColor } from "components/button";
import { Content, Header, Modal } from "components/modal";
import { ReactNode, useState } from "react";

import css from "./index.module.scss";

type Props = {
  buttonVertical?: boolean;
  closeButtonText?: string;
  confirmationButtonColor?: ButtonColor;
  confirmationButtonText?: string;
  confirmationMessage?: ReactNode;
  confirmationTitle?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export const ModalConfirm = ({
  buttonVertical = false,
  closeButtonText = "Cancel",
  confirmationButtonColor = "red",
  confirmationButtonText = "Confirm",
  confirmationMessage = "Do you really wish to proceed? This process cannot be undone.",
  confirmationTitle = "Are you sure?",
  onClose,
  onConfirm,
}: Props) => {
  const [loading, loadingSet] = useState(false);

  return (
    <Modal close={onClose} maxWidth={400}>
      <Header title={<strong>{confirmationTitle}</strong>} />
      <Content>
        <p className={css.description}>{confirmationMessage}</p>

        <div className={clsx(css.buttons, buttonVertical && css.vertical)}>
          <Button color="gray" disabled={loading} onClick={() => onClose()}>
            {closeButtonText}
          </Button>
          <Button
            color={confirmationButtonColor}
            loading={loading}
            onClick={async () => {
              loadingSet(true);
              await onConfirm();
              onClose();
            }}
          >
            {confirmationButtonText}
          </Button>
        </div>
      </Content>
    </Modal>
  );
};
